// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G5qq","name":"styles_name__1Bmw5","phone":"styles_phone__cwW4o"};